<div class="recover-password-page" [class.recover-password-page--ia-mode]="iaMode()">
  @if (iaMode() && sentTo()) {
  <!-- APR-4028 — confirmação do envio no celular do IA mode, no padrão do "Confirme seu e-mail". -->
  <div class="recover-sent" data-testid="recoverPasswordMessageSent">
    <div class="recover-sent__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 7 9 6 9-6" />
      </svg>
    </div>
    <h1 class="recover-sent__title">Confira seu e-mail</h1>
    <p class="recover-sent__text">
      Se existir uma conta com <strong>{{ sentTo() }}</strong>, enviamos um link para você criar uma nova senha.
      Veja também a pasta de spam.
    </p>
    <button type="button" class="recover-sent__primary" data-testid="recoverPasswordButtonBackToLogin" (click)="redirectToLogin()">
      Voltar ao login
    </button>
  </div>
  } @else {
  <div class="recover-password-form">
    @if (iaMode()) {
    <div class="recover-password-heading">
      <h1 class="recover-password-heading__title" data-testid="recoverPasswordMessageTitle">Esqueceu sua senha?</h1>
      <p class="recover-password-heading__text">
        Digite o e-mail da sua conta. Vamos enviar um link para você criar uma nova senha.
      </p>
    </div>
    }
    <form class="space-y-6" [formGroup]="form" (submit)="onSubmit()">
      <aprova-input
        id="email"
        inputType="email"
        inputClass="h-11"
        [control]="form.controls.email"
        label="E-mail"
        [placeholder]="iaMode() ? 'nome@email.com' : 'Digite o seu e-mail'"
        [inputMode]="iaMode() ? 'email' : 'text'"
        [required]="true"
        [errorMessages]="{
        required: 'Ops! Email precisa ser preenchido!',
        email: 'Ops! Email invalido!',
      }"
      />

      @if (!iaMode()) {
      <div class="flex justify-start items-center">
        <div
          class="text-sm leading-6 font-semibold text-aprova hover:text-aprova/80 cursor-pointer"
          (click)="redirectToLogin()"
        >
          Voltar ao login
        </div>
      </div>
      }

      @if (data$ | async; as data) { @if(!data.hideRecaptcha) {
      <aprova-recaptcha [recaptchaFormControl]="form.controls.recaptchaReactive" />
      } }
      <aprova-button
        id="btn-recover-password-submit"
        buttonType="button"
        class="inline-flex w-full h-10"
        buttonClass="inline-flex items-center justify-center rounded-md bg-aprova px-3 md:py-1.5 py-3 sm:text-sm leading-6 text-white shadow-sm hover:bg-aprova/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        [isLoading]="loading()"
        [label]="iaMode() ? 'Enviar link' : 'Recuperar senha'"
        loadingLabel="Enviando e-mail"
        (click)="onSubmit()"
      />

      @if (iaMode()) {
      <button type="button" class="recover-password-back" data-testid="recoverPasswordButtonBack" (click)="redirectToLogin()">
        Voltar ao login
      </button>
      }
    </form>
  </div>
  }
</div>
